import { nullishDefault } from '../helpers/nullishDefault';
import { ClassificationClass } from './classificationClass';
import { ClassificationDetection } from './classificationDetection';
import { z } from 'zod';

export type Classification = z.infer<typeof Classification>;

export const Classification = z.object({
    classes: nullishDefault(z.array(ClassificationClass), []),
    detections: nullishDefault(z.array(ClassificationDetection), []),
});
